import React, { useState } from "react";
import moment from "moment";
import Alert from "../../../controls/Alert";

const TripTimesValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  }); 

  let field = null;
  let error = false;
  let errorMessage = "";

  if (!error && (record.actualCargo === null || isNaN(record.actualCargo))) {
    error = true;
    errorMessage = "'Actual Cargo' is Required";
  }
  
  // if (!error && (record.actualCargo > record.maxPayload)) {
  //   error = true;
  //   errorMessage = "'Actual Cargo' greater than aircraft max payload";
  // }
  
  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {        
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default TripTimesValidator;